<script setup lang="ts">
import { onMounted } from 'vue'
import { RouterView } from 'vue-router'
import UserStateWatcher from '@/components/UserStateWatcher.vue'
import PageChange from '@/components/PageChange.vue'
import RedPacketRainManager from '@/components/RedPacketRain/Manager.vue'
import { generateDeviceId } from '@/utils/fingerprint'
import { hideLoadingAnimation } from '@/utils/loading'
import { saveShareCodeFromUrl } from '@/utils/shareCode'

onMounted(() => {
  // 应用挂载完成，隐藏加载动画
  hideLoadingAnimation()
  generateDeviceId()
  saveShareCodeFromUrl()
})
</script>

<template>
  <RouterView />
  <UserStateWatcher />
  <PageChange />
  <RedPacketRainManager />
</template>
